<!-- eslint-disable max-len -->
<template>
  <div>
    <Card title="Transfer History">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <date-range-picker
                  ref="picker"
                  :timePicker="false"
                  :showDropdowns="false"
                  :max-date="maxDate"
                  v-model="dateRange"
                  :opens="'right'"
                  @update="onChangeDate"
                  :auto-apply="true"
                >
                  <template v-slot:input="picker" >
                    From: {{ moment(picker.startDate) }} - To: {{ moment(picker.endDate) }}
                  </template>
                </date-range-picker>
              </div>
            </div>
          </div>
          <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
          </data-tables-server>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import helperMixins from '../mixins/helpers.mixins';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';
import { Button } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';

const displayingItems = 50;

export default {
  name: 'WithdrawHistoryPage',
  mixins: [helperMixins],
  data() {
    return {
      isLoading: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'artist.name',
        label: 'Artist Name',
      }, {
        prop: 'artist.email',
        label: 'Email',
      }, {
        prop: 'payment_date',
        label: 'Payment Date',
      }, {
        prop: 'amount',
        label: 'Amount',
      }, {
        prop: 'status_text',
        label: 'Status',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        sortby: 'id',
        sortorder: 'desc',
        start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      dateRange: {
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        // startDate: '2021-01-19',
        // endDate: '2021-10-19',
      },
      maxDate: moment().format('YYYY-MM-DD'),
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListWithdrawHistory(this.filter);
    // this.refineData();
  },
  computed: {
    ...mapGetters('FinanceModule', ['listWithdrawHistory']),
  },
  watch: {
    listWithdrawHistory: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listWithdrawHistory.data !== undefined) {
          this.data = this.listWithdrawHistory.data.data.map((withdraw) => {
            const status_text = withdraw.status === 3 ? 'Transferred' : 'Reject';
            if (withdraw.payment_date) {
              withdraw.payment_date = moment(withdraw.payment_date).format('YYYY-MM-DD HH:mm:ss');
            }
            return { ...withdraw, status_text, amount: `$${this.formatPrice(parseFloat(withdraw.amount).toFixed(2))}` };
          });
          this.total = this.listWithdrawHistory.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('FinanceModule', ['requestListWithdrawHistory']),
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    filterFormatUtc(params){
      const startUtc = moment(this.filter.start_date).utc().format('YYYY-MM-DD HH:mm:ss');
      const endUtc = moment(this.filter.end_date).utc().format('YYYY-MM-DD HH:mm:ss');
      return {
        ...this.filter,
        ...params,
        start_date: startUtc,
        end_date: endUtc,
      }
    },
    async search() {
      await this.requestListWithdrawHistory(this.filterFormatUtc({}));
      // this.refineData();
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'id',
        sortorder: 'desc',
        start_date: '',
        end_date: '',
      };
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListWithdrawHistory(this.filterFormatUtc({}));
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        start_date: moment(res.startDate).format('YYYY-MM-DD'),
        end_date: moment(res.endDate).format('YYYY-MM-DD'),
      };
      await this.search();
    },
  },
  components: {
    VueCustomTooltip,
    DateRangePicker,
    Button,
    Card,
  },
};
</script>
<style>
.daterangepicker .calendars{
  display:flex !important;
}
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/WithdrawHistory.vue